// extracted by mini-css-extract-plugin
module.exports = {"title":"src-components-FormResponse-ConflictsModal-styles___title","list":"src-components-FormResponse-ConflictsModal-styles___list"};